import Vue from 'vue'
import Router from 'vue-router'
const routerOptions = [
  { path: '/', component: 'Home', name: 'Home'},
  { path: '/about', component: 'About', name: 'About' },
  { path: '/terms', component: 'Terms', name: 'Terms' },
  { path: '/contact', component: 'Contact', name: 'Contact' },
  { path: '/secure', component: 'Secure', name: 'Secure' },
  { path: '/login', component: 'Login', name: 'Login' },
  { path: '/subscribe', component: 'Subscribe', name: 'Subscribe' },
  { path: '/dashboard', component: 'Dashboard', name: 'Dashboard' },
  { path: '/vox', component: 'Vox', name: 'Vox' },
  { path: '/apistep', component: 'ApiStep', name: 'ApiStep' },
  { path: '/python', component: 'Python', name: 'Python' },
  { path: '/curl', component: 'Curl', name: 'Curl' },
  { path: '/javascript', component: 'Javascript', name: 'Javascript' },
  { path: '/apiguide', component: 'Apiguide', name: 'Apiguide' },
  { path: '/payment', component: 'Payment', name: 'Payment' },
  { path: '/checkoutcancel', component: 'Checkoutcancel', name: 'Checkoutcancel' },
  { path: '/checkoutsuccess', component: 'Checkoutsuccess', name: 'Checkoutsuccess' },
  { path: '/pricing', component: 'Pricing', name: 'Pricing' },
  { path: '*', component: 'NotFound' }
]
const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import(`@/components/${route.component}.vue`)
  }
})
Vue.use(Router)
export default new Router({
  routes,
  mode: 'history'
})




// WEBPACK FOOTER //
// ./src/router/index.js